var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSinglePerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 26,
  "aria-hidden": "true"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#201D1D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.154 12.26a8.5 8.5 0 0 1-1.28 1.33c2.763 1.617 3.934 3.24 3.934 6.717 0 1.879-3.34 3.35-8.49 3.35s-8.489-1.471-8.489-3.35c0-3.477 1.171-5.1 3.934-6.718a8.5 8.5 0 0 1-1.28-1.328C1.405 14.243.052 16.327.052 20.307c0 1.206.647 2.886 3.729 4.044 1.923.722 3.797 1.12 6.537 1.12 2.741 0 4.615-.398 6.538-1.12 3.082-1.158 3.73-2.838 3.73-4.044 0-3.98-1.355-6.064-4.432-8.046z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.318 13.456c3.455 0 6.115-2.699 6.115-6.728C16.433 2.697 13.77 0 10.318 0 6.864 0 4.204 2.699 4.204 6.728c0 4.03 2.661 6.728 6.114 6.728m0-11.642c2.392 0 4.337 1.813 4.337 4.914s-1.945 4.914-4.337 4.914-4.337-1.814-4.337-4.914 1.946-4.914 4.337-4.914"
}))));
export default SvgSinglePerson;